export class CustomerLoyaltyRedemptionDto {
  transactionId: number;
  orderId: number;
  transactionCreatedDate: Date;
  merchantId: number;
  merchantName: string;
  brandId: number;
  customerId: number;
  loyaltyPoints: number;
  stamps: number;
}
